import { IconPropsType } from '..';

export const PlinkoIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_14520_359810)">
      <path d="M15.7895 3.75C18.1118 3.75 20 5.61841 20 7.91447C20 8.77631 19.7368 9.57895 19.2829 10.2434C19.2039 10.3684 19.1118 10.4934 19.0066 10.6184C15.8882 14.3421 6.375 16.2763 6.35527 16.25C8.93421 14.7171 10.2434 13.2368 10.1974 13.2105C7.46711 14.6118 4.06579 15.5592 0 16.0526C2.45395 14.9671 4.75658 13.6053 6.91447 11.9671C10.1447 9.51315 11.1053 6.67106 12.8026 4.98685L12.7434 5.04605L12.8553 4.9342C13.6118 4.20394 14.6447 3.75659 15.7895 3.75659V3.75ZM15.7697 4.78947C14.0263 4.78947 12.6118 6.19078 12.6118 7.91447C12.6118 9.63815 14.0263 11.0395 15.7697 11.0395C17.5132 11.0395 18.9276 9.63815 18.9276 7.91447C18.9276 6.19078 17.5132 4.78947 15.7697 4.78947Z" />
    </g>
    <defs>
      <clipPath id="clip0_14520_359810">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
